<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false" mat-icon-button
        (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span><b>Charitable Contribution Grant</b></span>
</mat-toolbar> -->
<div class="mobile-action-bar">
    <div class="action-mobile-button warn-button" (click)="onCancel()"
        color="warn">Cancel</div>
    <div class="action-mobile-button secondary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSaveAsDraft()"
        color="primary">Save</div>
    <div class="action-mobile-button primary-button" *ngIf="isShowSaveAsDraft"
        (click)="onSubmit()"
        color="primary">Submit</div>
    <div class="action-mobile-button warn-button" *ngIf="(asAnApprovar &&
        !isApproved)"
        (click)="onReject()" color="warn">Reject</div>
    <div class="action-mobile-button primary-button" *ngIf="(asAnApprovar &&
        !isApproved)"
        (click)="onApprove()"
        color="primary">Approve</div>
    <!-- <button mat-flat-button fxFlex *ngIf="isShowReassignBtn"
            (click)="onWithdrawReject('Reassigned')" color="primary">Reassign To CIT</button> -->
    <div class="action-mobile-button warn-secondary-button" *ngIf="!isApproved &&
        !asAnApprovar
        && !atOeBs"
        (click)="onWithdrawn()"
        color="warn">Withdraw</div>
</div>
<div class="info-container">
    <mat-card-subtitle class="leading-9">
        <p style="color:red;">
            <b>*NOTE :</b> UP TO $3,000 REQUIRES DIRECTOR/GENERAL
            MANAGER APPROVAL; $3,000 TO $50,000 REQUIRES
            VP/OFFICER APPROVAL; $50,000 AND ABOVE REQUIRES
            PRESIDENT/CEO APPROVAL.
        </p>
        <p>
            CORPORATE RESPONSIBILITY & COMMUNITY AFFAIRS AND ACCOUNTS
            PAYABLE WILL NOT PROCESS ANY CONTRIBUTION
            REQUEST WITHOUT REQUIRED APPROVALS.
        </p>
        <p>
            FOR MORE INFORMATION SEE POLICY:
            <a
                href="https://teams.sp.lgeenergy.int/sites/peoplelink/_layouts/15/WopiFrame.aspx?sourcedoc=/sites/peoplelink/Archive%20Policies/Community%20Investments.docx&action=default&DefaultItemOpen=1"
                target="_blank">Community Investments (Non-Foundation)
                and Sponsorships</a>
        </p>
        <p>
            <a
                href="https://teams.sp.lgeenergy.int/sites/ITTrainingHub/SitePages/Product%20Page.aspx?ProductFamily=Contributions/Grant
                Software&Product=Contributions/Grant Software"
                target="_blank">General Instructions & Job Aids</a>
        </p>
        <p>
            <b>*</b> = Mandatory
        </p>
    </mat-card-subtitle>
</div>
<div class="content" [@routeAnimation]="true">

    <form [formGroup]="ccForm" (keydown.enter)="$event.preventDefault()"
        class="form-content" enctype="multipart/form-data">
        <!-- <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center"
            [fxShow.xs]="true" [fxShow.sm]="true"
            [fxShow]="false">
            <button mat-fab (click)="onCancel()" color="warn">Cancel</button>
            <button mat-fab *ngIf="(asAnApprovar && !isApproved)"
                (click)="onReject()" color="warn">Reject</button>
            <button mat-fab *ngIf="asAnApprovar" (click)="onApprove()"
                color="primary">Approve</button>
            <button mat-fab *ngIf="!isApproved && !asAnApprovar && !atOeBs"
                (click)="onWithdrawn()"
                color="warn">Withdraw</button>
        </div> -->
        <mat-card *ngIf="isShowEmpID">
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <mat-label>Employee Id (For Test Only)</mat-label>
                    <input type="text" matInput placeholder="Employee Id (For
                        Test Only)" required maxlength="7"
                        formControlName="userId" [attr.disabled]='!isReadOnly'>
                    <mat-hint>E123456 / N123456</mat-hint>
                </mat-form-field>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-content fxLayout="column">
                <mat-form-field>
                    <mat-label>Request Name </mat-label>
                    <input type="text" matInput placeholder="Request Name *"
                        maxlength="50" formControlName="formCCName"
                        [attr.disabled]='!isReadOnly'>
                </mat-form-field>
            </mat-card-content>
        </mat-card>

        <mat-card fxLayout="row" fxLayoutGap="30px" fxLayout.sm="column"
            fxLayout.xs="column">

            <mat-form-field>
                <mat-label>Request Date</mat-label>
                <input matInput [min]="minEffdt" [matDatepicker]="picker1"
                    readonly placeholder="Request Date *"
                    formControlName="effdt" [disabled]='!isReadOnly'>
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-hint align="end">choose from dropdown ^</mat-hint>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Due Date</mat-label>

                <input matInput [min]="minDuedt" [matDatepicker]="picker2"
                    readonly placeholder="Due Date"
                    formControlName="dueDate" [disabled]='!isReadOnly'>
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                <mat-hint align="end">choose from dropdown ^</mat-hint>
            </mat-form-field>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-form-field>
                <mat-label>Service Area(s) </mat-label>
                <mat-select placeholder="Service Area(s) *"
                    formControlName="serviceArea" multiple
                    [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let serviceArea of serviceAreas"
                        [value]="serviceArea">{{serviceArea}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>
                <b>Purpose Of Grant</b>
            </mat-card-subtitle>
            <mat-form-field>
                <mat-label>Primary Mission Of Organization</mat-label>
                <mat-select placeholder="Primary Mission Of Organization *"
                    formControlName="grantPurpose"
                    [disabled]='!isReadOnly'>
                    <mat-option value="ARTS">ARTS</mat-option>
                    <mat-option value="DIVERSITY">DIVERSITY</mat-option>
                    <mat-option value="ECONOMIC DEVELOPMENT">ECONOMIC
                        DEVELOPMENT</mat-option>
                    <mat-option value="EDUCATION">EDUCATION</mat-option>
                    <mat-option value="ENVIRONMENT">ENVIRONMENT</mat-option>
                    <mat-option value="HEALTH & HUMAN SERVICES">HEALTH & HUMAN
                        SERVICES</mat-option>
                    <mat-option value="HEALTH & HUMAN SERVICES - LOW INCOME">HEALTH
                        & HUMAN SERVICES - LOW INCOME
                    </mat-option>
                    <mat-option value="OTHER">OTHER</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>

        <mat-card formGroupName="OrgInfo" fxLayout="column">
            <mat-card-subtitle>
                <b>Organization Information</b>
                <p> Please edit the mailing address below if needed.</p>
            </mat-card-subtitle>
            <mat-form-field>
                <mat-label>Organization Name </mat-label>
                <input type="text" matInput placeholder="Organization Name *"
                    [attr.maxlength]="isMaxLength?
                    ccForm.get(['OrgInfo','name']).value.length : 80"
                    formControlName="name" readonly>
                <mat-hint *ngIf="isMaxLength" style="color:red">The organization
                    name has exceeded the max length
                    allowed by current system. Please provide a new name in the
                    "Payable To" field.</mat-hint>
            </mat-form-field>
            <div style="margin-bottom: 10px">
                <mat-card-subtitle>Is "Payable To" name different than the
                    Organization Name? *</mat-card-subtitle>
                <mat-radio-group formControlName="payToOption"
                    [disabled]='!isReadOnly || isMaxLength'>
                    <mat-radio-button color="primary" value="yes">Yes</mat-radio-button>
                    <mat-radio-button color="primary" value="no">No</mat-radio-button>
                </mat-radio-group>
            </div>
            <mat-form-field *ngIf="payToOption">
                <mat-label>Payable To </mat-label>
                <input type="text" matInput placeholder="Payable To *"
                    maxlength="80" formControlName="payTo"
                    [readonly]='!isReadOnly'>
            </mat-form-field>


            <mat-form-field>
                <mat-label>EIN </mat-label>
                <input type="text" matInput placeholder="EIN *" maxlength="10"
                    formControlName="EIN" readonly>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Address1 </mat-label>
                <input type="text" matInput placeholder="Address1 *"
                    maxlength="35" formControlName="address1"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Address2</mat-label>
                <input type="text" matInput placeholder="Address2"
                    maxlength="35" formControlName="address2"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>City </mat-label>
                <input type="text" matInput placeholder="City *" maxlength="25"
                    formControlName="city"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>State </mat-label>
                <mat-select placeholder="State *" formControlName="state"
                    [disabled]='!isReadOnly'>
                    <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Zip Code </mat-label>
                <input type="text" matInput placeholder="Zip Code *"
                    maxlength="9" formControlName="zipCode"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Tax-Excempt Status </mat-label>
                <input type="text" matInput placeholder="Tax-Exempt Status"
                    maxlength="15"
                    [value]="getTaxExemptStatus(ccForm.get(['OrgInfo','subsection_501']).value)"
                    readonly>
            </mat-form-field>
            <mat-form-field *ngIf='hasRole(" DEV" )'>
                <mat-label>Tax-Excempt Status </mat-label>
                <mat-select placeholder="Tax Exempt Status *"
                    formControlName="subsection_501">
                    <mat-option *ngFor="let subsection of taxExemptList"
                        [value]="subsection">
                        {{getTaxExemptStatus(subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>

        <mat-card formGroupName="OrgContactInfo" fxLayout="column"
            fxLayoutGap="8px">
            <mat-card-subtitle>
                <b>Organization Contact Information</b>
            </mat-card-subtitle>
            <mat-form-field>
                <mat-label>Title </mat-label>
                <mat-select placeholder="Title *" formControlName="title"
                    [disabled]='!isReadOnly'>
                    <mat-option value="Mr.">Mr.</mat-option>
                    <mat-option value="Mrs.">Mrs.</mat-option>
                    <mat-option value="Ms.">Ms.</mat-option>
                    <mat-option value="Dr.">Dr.</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label>First Name </mat-label>
                <input type="text" matInput placeholder="First Name *"
                    maxlength="150" formControlName="firstName"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Last Name </mat-label>
                <input type="text" matInput placeholder="Last Name *"
                    maxlength="150" formControlName="lastName"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Phone Number </mat-label>
                <input type="text" phone ngControl="phone" matInput
                    placeholder="Phone Number *" maxlength="12"
                    formControlName="phone" [attr.disabled]='!isReadOnly'>
                <mat-hint>Example: XXX-XXX-XXXX</mat-hint>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Email Address </mat-label>
                <input type="email" matInput placeholder="Email Address *"
                    maxlength="254" formControlName="email"
                    [attr.disabled]='!isReadOnly'>
                <mat-hint>Example: you@example.com</mat-hint>
            </mat-form-field>
        </mat-card>

        <mat-card class="mat-margin" fxLayout="column">
            <mat-card-subtitle>Is this an Event or Program? *</mat-card-subtitle>
            <mat-card-content>
                <mat-radio-group formControlName="eventOrProgram"
                    [disabled]='!isReadOnly'>
                    <mat-radio-button color="primary" value="program">Program</mat-radio-button>
                    <mat-radio-button color="primary" value="event">Event</mat-radio-button>
                </mat-radio-group>
            </mat-card-content>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-form-field>
                <mat-label>Event/Program Name </mat-label>
                <input type="text" matInput placeholder="Event/Program Name *"
                    maxlength="50"
                    formControlName="eventOrProgramName"
                    [attr.disabled]='!isReadOnly'>
            </mat-form-field>
        </mat-card>

        <mat-card *ngIf="eventOrProgram" fxLayout="column">
            <mat-card-subtitle>Does sponsorship/contribution include a table? *</mat-card-subtitle>
            <mat-card-subtitle>If Yes, who is responsible for filling the table?</mat-card-subtitle>
            <mat-radio-group formControlName="contribTable"
                [disabled]='!isReadOnly'>
                <mat-radio-button color="primary" value="yes">Yes</mat-radio-button>
                <mat-radio-button color="primary" value="no">No</mat-radio-button>
            </mat-radio-group>
            <mat-form-field *ngIf="contribTable">
                <mat-label>Who is responsible for filling the table?
                </mat-label>
                <input type="text" matInput maxlength="25"
                    formControlName="contribTableDescr"
                    [readonly]='!isReadOnly'>
            </mat-form-field>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>
                <b>Payment Method *</b>
            </mat-card-subtitle>
            <mat-card-subtitle>
                Please confirm the vendor accepts a credit card payment for this
                contribution.
            </mat-card-subtitle>
            <mat-card-subtitle>
                If credit card selected here, Corporate Responsibility will
                process the payment. Do not use your
                Corporate Card or Pro Card for this payment.
            </mat-card-subtitle>
            <mat-radio-group formControlName="payment" [disabled]='!isReadOnly'>
                <mat-radio-button color="primary" value="CHECK">Check</mat-radio-button>
                <mat-radio-button color="primary" value="CREDIT">Credit Card</mat-radio-button>
            </mat-radio-group>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>Will there be goods and services received as a
                result of a contribution? *
            </mat-card-subtitle>
            <mat-card-subtitle> If yes, please contact Corporate Responsibility
                at 502-627-3225. A sponsored table is
                not considered goods or services.
            </mat-card-subtitle>
            <mat-radio-group formControlName="goodsAndServices"
                [disabled]='!isReadOnly'>
                <mat-radio-button color="primary" value="yes">Yes</mat-radio-button>
                <mat-radio-button color="primary" value="no">No</mat-radio-button>
            </mat-radio-group>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>How will this contribution/sponsorship be
                publicly acknowledged? *</mat-card-subtitle>
            <mat-form-field>
                <textarea formControlName="publicAck" maxlength="254" matInput
                    matTextareaAutosize
                    matAutosizeMinRows="2" matAutosizeMaxRows="5"
                    [attr.disabled]='!isReadOnly'></textarea>
            </mat-form-field>
        </mat-card>



        <mat-card fxLayout="column">
            <mat-card-subtitle>Have we supported the organization/event in the
                past? *</mat-card-subtitle>
            <mat-radio-group formControlName="supportedPast"
                [disabled]='!isReadOnly'>
                <mat-radio-button color="primary" value="yes">Yes</mat-radio-button>
                <mat-radio-button color="primary" value="no">No</mat-radio-button>
            </mat-radio-group>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>
                Check Memo
            </mat-card-subtitle>
            <mat-card-subtitle>For internal delivery <b>ONLY</b>.</mat-card-subtitle>
            <mat-form-field>
                <mat-label>Send To </mat-label>
                <textarea matInput formControlName="checkMemo" maxlength="45"
                    placeholder="Send To:" matTextareaAutosize
                    matAutosizeMinRows="1" matAutosizeMaxRows="1"
                    [attr.disabled]='!isReadOnly'></textarea>
                <mat-hint>Example: Claire Simms – LGE 11</mat-hint>
            </mat-form-field>
        </mat-card>

        <mat-card fxLayout="column">
            <mat-card-subtitle>
                <mat-card-subtitle>
                    <b>Accounting Distribution *</b>
                    <P>Payments cannot be split between two companies in the
                        same request. </P>
                    <P>If the payment is to be split between companies, two
                        request forms must be completed.</P>
                </mat-card-subtitle>
            </mat-card-subtitle>
            <div class="account-dist-container">
                <table *ngIf="accDistData.length" 
                    formArrayName="AccDistribution">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Company</th>
                            <th>Project</th>
                            <th>Task</th>
                            <th>Exp-Type</th>
                            <th>Exp-Org</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i"
                            *ngFor="let accDist of
                            ccForm.get('AccDistribution')['controls']; let i=
                            index">
                            <td>{{ i+1 }}</td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="company"
                                        [disabled]='!isReadOnly'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'company')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let company of
                                            accDistData[i].company"
                                            [value]="company.code">{{company.descr}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="project"
                                        [disabled]='!isReadOnly'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'project')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let project of
                                            accDistData[i].project"
                                            [value]="project.project">{{project.project}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="task"
                                        [disabled]='!isReadOnly'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'task')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let task of
                                            accDistData[i].task"
                                            [value]="task.task">
                                            {{task.task}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expType"
                                        [disabled]='!isReadOnly'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expType')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expType of
                                            accDistData[i].expType"
                                            [value]="expType.code">{{expType.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <mat-select formControlName="expOrg"
                                        [disabled]='!isReadOnly'
                                        (ngModelChange)="onAccDistSelect($event,
                                        i, 'expOrg')">
                                        <mat-option value="">--</mat-option>
                                        <mat-option *ngFor="let expOrg of
                                            accDistData[i].expOrg"
                                            [value]="expOrg.code">
                                            {{expOrg.code}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field>
                                    <input style="text-align: center;"
                                        type="text" matInput
                                        (change)="onAmountChange($event.target,i)"
                                        (input)="calculateTotalAmount()"
                                        maxlength="11" formControlName="amount"
                                        [attr.disabled]='!isReadOnly'>
                                </mat-form-field>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style="text-align: center;">
                                <b>Total Amount:</b>
                            </td>
                            <td style="text-align: center;">
                                <span>
                                    <b>$ {{totalAmount}}</b>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-card>
        <mat-card fxLayout="column" fxLayoutGap="16px" [fxShow.xs]="false"
            [fxShow.sm]="false">
            <mat-card-subtitle>
                <b>Attachments</b>
            </mat-card-subtitle>
            <mat-card>
                <mat-card-subtitle>Please upload a completed form W-9 for this
                    request.
                    <b>(PDF Only)*</b>
                </mat-card-subtitle>
                <mat-card-subtitle>Please Note: the provided W-9 must be the
                    version
                    <a href="https://lge-ku.com/w9" target="_blank">here.</a>
                </mat-card-subtitle>
                <mat-card-content fxLayout="column">
                    <input type="file" accept="application/pdf"
                        (change)="onW9FileChange($event)" #fileInput1
                        [disabled]='!isReadOnly'>
                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            w9FormName">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="w9FormName.length != 0"
                                (click)="DownloadFormccW9File()">move_to_inbox
                            </mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="w9FormName.length != 0 && isReadOnly"
                                (click)="resetFileInput1()">delete_forever
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file }}
                            </h4>
                        </a>
                    </mat-nav-list>
                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="w9FormName.length != 0">
                        <a class="list-item" mat-list-item *ngFor="let file of
                            w9FormName">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadFormccW9File()">move_to_inbox
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">
                                {{ file }}
                            </h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-subtitle>Additional attachment if needed.
                    <b>(PDF Only)</b>
                </mat-card-subtitle>
                <mat-card-content>
                    <input type="file" accept="application/pdf"
                        (change)="onAddAttachFileChange($event)" #fileInput2
                        multiple [disabled]='!isReadOnly'>

                    <mat-nav-list fxLayout="column" fxLayoutGap="10px">
                        <a class="list-item" mat-list-item
                            *ngIf="fileNames.length != 0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                (click)="DownloadFormccAllAddAttachFile()">
                                move_to_inbox</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item
                            *ngIf="fileNames.length != 0 && isReadOnly">
                            <mat-icon color="warn" class="icon-cursor"
                                color="warn"
                                mat-list-icon (click)="resetFileInput2()">
                                delete_forever</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Remove all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item *ngFor="let file of
                            fileNames; let i= index">
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="primary"
                                *ngIf="fileNames.length != 0"
                                (click)="DownloadFormccAddAttachFile(file)">
                                move_to_inbox</mat-icon>
                            <mat-icon class="icon-cursor" mat-list-icon
                                color="warn"
                                *ngIf="fileNames.length != 0 && isReadOnly"
                                (click)="removeFile(file)">delete_forever
                            </mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file }}</h4>
                        </a>
                    </mat-nav-list>

                    <!-- <mat-nav-list fxLayout="column" fxLayoutGap="10px"
                        *ngIf="fileNames.length != 0">
                        <a class="list-item" mat-list-item
                            *ngIf="fileNames.length != 0">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadFormccAllAddAttachFile()">
                                move_to_inbox</mat-icon>
                            <h4 mat-line style="cursor: default;">
                                <b>Download all files</b>
                            </h4>
                        </a>
                        <a class="list-item" mat-list-item *ngFor="let file of
                            fileNames; let i= index">
                            <mat-icon class="icon-cursor" mat-list-icon
                                (click)="DownloadFormccAddAttachFile(file)">
                                move_to_inbox</mat-icon>
                            <h4 mat-line style="cursor: default;">{{i+1}}. {{
                                file }}</h4>
                        </a>
                    </mat-nav-list> -->
                </mat-card-content>
            </mat-card>
        </mat-card>

        <div fxLayout="row" [fxShow.xs]="false" [fxShow.sm]="false">
            <span>
                <mat-icon class="inline-icon" mat-list-icon>short_text</mat-icon>If
                unable to submit, complete all
                required fields.
            </span>
        </div>

    </form>
</div> <br><br>
<div class="action-bar">
    <div matRipple class="action-button warn-button" (click)="onCancel()"
        color="warn">Cancel</div>
    <div matRipple class="action-button secondary-button" *ngIf="isReadOnly &&
        !asAnApprovar &&
        isShowSaveAsDraft"
        (click)="onSaveAsDraft()" color="primary">Save As Draft</div>
    <div matRipple class="action-button primary-button" *ngIf="isReadOnly &&
        !asAnApprovar"
        (click)="onSubmit()"
        color="primary">{{isShowSaveAsDraft? 'Submit': 'Save'}}</div>
    <div matRipple class="action-button warn-button" *ngIf="(asAnApprovar && !isApproved)"
        (click)="onReject()"
        color="warn">Reject</div>
    <div matRipple class="action-button primary-button" *ngIf="asAnApprovar"
        (click)="onApprove()"
        color="primary">Approve</div>
    <div matRipple class="action-button warn-secondary-button" *ngIf="!isApproved && !asAnApprovar
        &&
        !atOeBs" (click)="onWithdrawn()"
        color="warn">Withdraw</div>
</div>